import type {Context} from '../types';
import type {JSONNode} from '@packages/shared/types/JSONNode';

// removes from product collection list as well as product and category pages.
export default function removeCartFormLabelPasswordPageFlag(context: Context) {
  const {nodeMap, parentMap} = context.tree;
  const {jsonNode} = context.node;

  const needed =
    isFormLabel(jsonNode) &&
    hasPasswordPageFlag(jsonNode) &&
    hasAddToCartWrapperAncestor(nodeMap, parentMap, jsonNode._id);

  return {
    needed,
    logData: {
      msg: 'removed password page flag from form label within Add to Cart',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (
        jsonNode.data &&
        jsonNode.data.form &&
        'passwordPage' in jsonNode.data.form
      ) {
        jsonNode.data.form.passwordPage = false;
      }
    },
  };
}

const hasAddToCartWrapperAncestor = (
  nodeMap: Map<string, JSONNode>,
  parentMap: Map<string, string>,
  nodeId: string
): boolean => {
  const parentId = parentMap.get(nodeId);
  if (!parentId) return false;
  const parentNode = nodeMap.get(parentId);
  // at the top of the tree, stop traversing
  if (!parentNode) return false;
  if (isAddToCartWrapper(parentNode)) {
    return true;
  }
  return hasAddToCartWrapperAncestor(nodeMap, parentMap, parentId);
};

const isAddToCartWrapper = (node: JSONNode) => {
  return node.type === 'CommerceAddToCartWrapper';
};

const isFormLabel = (node: JSONNode) => {
  return node.type === 'FormBlockLabel';
};

const hasPasswordPageFlag = (node: JSONNode) => {
  return node.data?.form?.passwordPage === true;
};
